@use '../../styles/mixins' as *;

.rf-support-content {
    // стекло карточек и пустого состояния: на тёмном — тёмная заливка
    --sc-card-top: var(--theme-sc-card-top);
    --sc-card-bottom: var(--theme-sc-card-bottom);
    --sc-state-top: var(--theme-sc-state-top);
    --sc-state-bottom: var(--theme-sc-state-bottom);

    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: min(440px, calc(100vw - 48px));
}

.rf-support-content--compact {
    min-width: min(400px, calc(100vw - 32px));
}

.rf-support-content__header {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-bottom: 4px;
}

.rf-support-content__description {
    color: var(--neutral-60);
    font-size: var(--fz-14);
    line-height: var(--lh-text);
}

.rf-support-content__list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.rf-support-content__card {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 16px;
    border: 1px solid var(--neutral-10);
    border-radius: 16px;
    background: linear-gradient(180deg, var(--sc-card-top), var(--sc-card-bottom)), var(--neutral-00);
    color: inherit;
    text-decoration: none;
    transition:
        transform 0.16s ease,
        border-color 0.16s ease,
        box-shadow 0.16s ease;
}

.rf-support-content__card:hover {
    transform: translateY(-1px);
    border-color: rgba(34, 139, 230, 0.28);
    box-shadow: 0 14px 32px rgba(13, 39, 80, 0.1);
}

.rf-support-content__card-accent {
    width: 4px;
    min-width: 4px;
    align-self: stretch;
    border-radius: 999px;
    background: linear-gradient(135deg, var(--primary-60-main), #5b8cff);
}

.rf-support-content__card-body {
    min-width: 0;
    flex-grow: 1;
}

.rf-support-content__card-title {
    @include type-title-row;
    color: var(--neutral-90);
}

.rf-support-content__card-meta {
    margin-top: 4px;
    color: var(--neutral-60);
    font-size: var(--fz-13);
    line-height: var(--lh-ui);
}

.rf-support-content__card-icon {
    flex-shrink: 0;
    color: var(--neutral-50);
}

.rf-support-content__state,
.rf-support-content__empty {
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border: 1px solid var(--neutral-10);
    border-radius: 16px;
    background: linear-gradient(180deg, var(--sc-state-top), var(--sc-state-bottom));
    color: var(--neutral-60);
    text-align: center;
    padding: 16px;
}

@media (max-width: 768px) {
    .rf-support-content,
    .rf-support-content--compact {
        min-width: min(100vw - 24px, 400px);
    }
}
